import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'add-factor-popup',
    templateUrl: './add-factor-popup.component.html',
    styleUrls: ['./add-factor-popup.component.less'],
    standalone: false
})
export class AddFactorPopupComponent implements OnInit {
    form!: FormGroup;
    isEditMode: boolean = false;
    isSubmitting: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<AddFactorPopupComponent>,
        private readonly formBuilder: FormBuilder,
        private readonly http: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly toastrService: ToastrService
    ) { 
        this.isEditMode = this.data?.isEditMode || false;
    }

    ngOnInit(): void {
        const factorData = this.data?.factor || {};
        this.form = this.formBuilder.group({
            id: [factorData.id || null],
            code: [factorData.code || '', [Validators.required, Validators.maxLength(50)]],
            description: [factorData.description || '', [Validators.required, Validators.maxLength(2000)]],
            stage1: [factorData.stage1 || '', [Validators.required, Validators.maxLength(2000)]],
            stage2: [factorData.stage2 || '', [Validators.required, Validators.maxLength(2000)]],
            stage3: [factorData.stage3 || '', [Validators.required, Validators.maxLength(2000)]],
            stage4: [factorData.stage4 || '', [Validators.required, Validators.maxLength(2000)]],
        });
        
        this.form.markAsPristine();
    }
    onSubmit(): void {
        if (this.form.invalid || this.isSubmitting) {
            return;
        }

        this.isSubmitting = true;

        const formData: any = {
            Code: this.form.value.code?.trim(),
            ProtocolId: this.data?.protocolId,
            Description: this.form.value.description?.trim() || null,
            Stage1: this.form.value.stage1?.trim() || null,
            Stage2: this.form.value.stage2?.trim() || null,
            Stage3: this.form.value.stage3?.trim() || null,
            Stage4: this.form.value.stage4?.trim() || null,
        };

        if (this.isEditMode) {
            formData.ProtocolFactorId = this.data?.factor?.id || this.form.value.id;
        }

        const url = `${this.baseUrl}api/osh/protocol-factors`;
        const request = this.isEditMode ? this.http.put(url, formData) : this.http.post(url, formData);

        request.subscribe({
            next: (result: any) => {
                const action = this.isEditMode ? 'updated' : 'created';
                this.toastrService.success(`Factor was ${action} successfully!`);
                this.dialogRef.close(true);
            },
            error: (error) => {
                console.error('Error saving factor:', error);
                this.isSubmitting = false;
                
                let errorMessage = 'An unexpected error occurred. Please contact administrator.';
                
                if ((error.status === 400 || error.status === 409) && error.error?.message) {
                    errorMessage = error.error.message;
                }
                
                this.toastrService.error(errorMessage);
            }
        });
    }

    capitalizeFirst(event: Event, controlName: string): void {
        const input = event.target as HTMLInputElement | HTMLTextAreaElement;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const v = input.value;
        input.value = v.length > 0 ? v.charAt(0).toUpperCase() + v.slice(1) : v;
        input.setSelectionRange(start, end);
        this.form.get(controlName)?.setValue(input.value, { emitEvent: false });
    }

    backButtonHandler(event?: Event): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.dialogRef.close(false);
    }

    get canSubmit(): boolean {
        if (this.isEditMode) { 
            return this.form.valid && this.form.dirty && !this.isSubmitting;
        }
        return this.form.valid && !this.isSubmitting;
    }
}